import type { PostgrestError, SupabaseClient } from "@supabase/supabase-js";
import { supabase } from "@/integrations/supabase/client";

export const client = () => supabase as unknown as SupabaseClient;

/** Postgres error `hint` — the RPCs name their refusals there (`brief_empty`, …). */
export function errorHint(error: unknown): string | null {
  if (typeof error !== "object" || error === null) return null;
  const hint = (error as { hint?: unknown }).hint;
  return typeof hint === "string" ? hint : null;
}

export function raise(error: PostgrestError): never {
  const wrapped = new Error(error.message) as Error & { hint?: string; code?: string };
  wrapped.hint = error.hint ?? undefined;
  wrapped.code = error.code;
  throw wrapped;
}
